<template>
  <div class="full_loading">
    <img src="//www.gomlab.com/gomlab_v2/ui/gommarket/img/common/img_market_loading.gif">
  </div>
</template>

<style lang="scss" scoped>
@import '@/styles/_variable.scss';
.full_loading {
  position: fixed;
  top: 0; left: 0;
  width: 100%;
  height: 100vh;
  background: rgba(0, 0, 0,.5);
  z-index: 55;
  img {
    position: absolute;
    top: 50%; left: 50%;
    transform: translate(-50%, -50%);
  }
}
</style>
